<app-loader *ngIf="isEdit && periodLoading$"></app-loader>

<form
  *ngIf="isEdit ? period : true"
  [formGroup]="period && period.is_esdp ? ESDPPeriodForm : periodForm"
  (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <div *ngIf="errors && errors.detail" class="alert alert-danger">
      {{ errors.detail }}
    </div>
    <div *ngIf="!isEdit">
      <mat-form-field appearance="outline" (click)="start_date_picker.open()">
        <mat-label>Дата начала</mat-label>
        <input
          readonly
          required
          [errorStateMatcher]="matcher"
          matInput
          [matDatepicker]="start_date_picker"
          formControlName="start_date" />
        <mat-hint>DD.ММ.ГГГГ</mat-hint>
        <mat-datepicker-toggle
          matSuffix
          [for]="start_date_picker"></mat-datepicker-toggle>
        <mat-datepicker #start_date_picker></mat-datepicker>
        <mat-error *ngIf="start_date!.errors?.required">{{
          requiredErrorMessage
        }}</mat-error>
        <mat-error>{{ getMessageFormError('start_date') }}</mat-error>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field appearance="outline">
        <mat-label>Дни занятий</mat-label>
        <mat-select
          required
          [errorStateMatcher]="matcher"
          formControlName="lesson_days">
          <ng-container [ngSwitch]="period && period.is_esdp">
            <ng-container *ngSwitchCase="true">
              <mat-option
                *ngFor="let day of days.one | keyvalue"
                [value]="day.key">
                {{ day.value }}
              </mat-option>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <mat-option
                *ngFor="let day of days.two | keyvalue"
                [value]="day.key">
                {{ day.value }}
              </mat-option>
            </ng-container>
          </ng-container>
        </mat-select>

        <mat-error *ngIf="lesson_days!.errors?.required">
          {{ requiredErrorMessage }}
        </mat-error>
        <mat-error>{{ getMessageFormError('lesson_days') }}</mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="!isEdit">
      <mat-form-field appearance="outline">
        <mat-label>Время занятий</mat-label>
        <input
          required
          type="time"
          matInput
          [errorStateMatcher]="matcher"
          formControlName="lesson_time" />
        <mat-error *ngIf="lesson_time!.errors?.required">{{
          requiredErrorMessage
        }}</mat-error>
        <mat-error>{{ getMessageFormError('lesson_time') }}</mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="!(period && period.is_esdp)">
      <mat-form-field appearance="outline">
        <mat-label>Дни вебинаров</mat-label>
        <mat-select
          required
          [errorStateMatcher]="matcher"
          formControlName="webinar_days">
          <mat-option *ngFor="let day of days.one | keyvalue" [value]="day.key">
            {{ day.value }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="webinar_days!.errors?.required">{{
          requiredErrorMessage
        }}</mat-error>
        <mat-error>{{ getMessageFormError('webinar_days') }}</mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="!isEdit">
      <mat-form-field appearance="outline">
        <mat-label>Время вебинаров</mat-label>
        <input
          required
          type="time"
          matInput
          [errorStateMatcher]="matcher"
          formControlName="webinar_time" />
        <mat-error *ngIf="webinar_time!.errors?.required">{{
          requiredErrorMessage
        }}</mat-error>
        <mat-error>{{ getMessageFormError('webinar_time') }}</mat-error>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <div mat-dialog-actions class="justify-content-end">
    <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
      Отмена
    </button>
    <app-button-with-progress
      typeBtn="submit"
      [loading$]="sendLoading$ | async"
      [label]="isEdit ? 'Сохранить' : 'Создать'"></app-button-with-progress>
  </div>
</form>
